<div class="message-label" *ngIf="showMobileAppAdvert()">
    <a [href]="getMobileLink()" (click)="displayInstallFromStore()"><span class="fas fa-mobile-alt"></span> Use our
        Mobile App to open and store plans.</a>
    <div *ngIf="displayInstallFromStoreLink">
        <br />
        <a href="{{getStoreLink()}}">Don't have it
            Installed? Install it here.</a>
    </div>


</div>